import { TAvailByDayResp } from '@/domain/Availability.domain';
import { TPricesForSchedules } from '@/domain/Prices.domain';

export const mapSchedulesWithPrices = (
    schedules: TAvailByDayResp,
    prices?: TPricesForSchedules
) => {
    if (!prices) {
        return schedules;
    }

    const pricesData = prices.schedules.reduce(
        (res, item) => {
            res[item.schedule_id] = item.price_from;

            return res;
        },
        {} as { [key: number]: number }
    );

    schedules[0]?.schedules?.forEach((schedule) => {
        schedule.price = pricesData[schedule.schedule_id] || prices.default;
    });

    return schedules;
};
